import { render, staticRenderFns } from "./ReservationCompleted.vue?vue&type=template&id=37f20621&"
import script from "./ReservationCompleted.vue?vue&type=script&lang=js&"
export * from "./ReservationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f20621')) {
      api.createRecord('37f20621', component.options)
    } else {
      api.reload('37f20621', component.options)
    }
    module.hot.accept("./ReservationCompleted.vue?vue&type=template&id=37f20621&", function () {
      api.rerender('37f20621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ReservationCompleted.vue"
export default component.exports